import React, { useEffect, useState, useMemo } from "react";
import Cookies from "js-cookie";

function CountryCheck() {
    const [loading, setLoading] = useState(false); // State to control loader visibility
    const [showZHMenu, setshowZHMenu] = useState(false); // State to control hello text visibility
    const [showZHMenuStatus, setshowZHMenuStatus] = useState(true); // State to control hello text visibility
    const [active_menu_loading, setactive_menu_loading] = useState(false); // State to control loader visibility
    //const [activeValueClass, setActiveValueClass] = useState(null); // State to track the active button
    const [activeClassDefault, setActiveClassDefault] = useState('');
    const [activeClassOthers, setActiveClassOthers] = useState('');

    const [toggleButton, setToggleButton] = useState('');
    const [toggleButtonUk, setToggleButtonUk] = useState('');
    const [toggleButtonEu, setToggleButtonEu] = useState('');

    useEffect(() => {
        
        async function fetchCountryData() {
            const controller = new AbortController(); // Create a new AbortController
            const timeoutId = setTimeout(() => controller.abort(), 50000); // Set a timeout for 50 seconds
            //setLoading(true); //for checking
            try {
                //const res = await fetch(`${ZhLocalizationRoot.apiUrl}/zh-localization-api/v1/zh-country-check`);
                const res = await fetch(`${ZhLocalizationRoot.apiUrl}/zh-localization-api/v1/zh-country-check`, {
                    cache: "no-store",
                    signal: controller.signal, // Attach the signal to fetch
                });
                clearTimeout(timeoutId); // Clear the timeout on successful fetch
                

                    if (!res.ok) {
                        throw new Error(`Error: ${res.status}`);
                    }
                    const data = await res.json();
                    

                    setToggleButton(data.toggle_button);
                    setToggleButtonUk(data.toggle_button_uk);
                    setToggleButtonEu(data.toggle_button_eu);

                    const localization_menu_status = Cookies.get("localization_menu_status") || "";
                    const CountryCode_zhash = Cookies.get("CountryCode_zhash") || "";
                    const CountryCode_status_zhash = Cookies.get("CountryCode_status_zhash") || "";

                    const pageSlugElement = document.getElementById("page_slug_dynamically_reactjs");
                    const pageSlug = pageSlugElement ? pageSlugElement.getAttribute("data-page-slug") : '';
                    sessionStorage.setItem("pageSlug", pageSlug);
                    // Check if it's empty
                    //if (localization_menu_status !== 'active') {
                    if (localization_menu_status && CountryCode_zhash === data.CountryCode_zhash) { }else{
                        sessionStorage.setItem("toggleButtonGlobal", "deactive");
                        //Cookies.set("localization_menu_status", deactive, { expires: 1 });
                        // Store specific values in cookies
                        if (data.CountryCode_status_zhash) {
                            Cookies.set("CountryCode_status_zhash", data.CountryCode_status_zhash, { expires: 1 });
                        }
                        if (data.CountryCode_zhash) {
                            Cookies.set("CountryCode_zhash", data.CountryCode_zhash, { expires: 1 });
                        }
                        if (data.countrycode_zhash_current_ip) {
                            Cookies.set("countrycode_zhash_current_ip", data.countrycode_zhash_current_ip, { expires: 1 });
                        }
                            

                        const is_active_menu = sessionStorage.getItem("is_active_menu");
                        const lastRedirectedSlug = sessionStorage.getItem("lastRedirectedSlug");
                        const country_code = data.CountryCode_zhash;
                        const country_code_status = data.CountryCode_status_zhash; // Correct variable for country status
                        let redirect_url = '';
                        const home_url =ZhLocalizationRoot.HomeUrl;
                        const active_slug = data.active_slug;
                        if (country_code_status !== 'Global' && lastRedirectedSlug !== country_code) {
                            sessionStorage.setItem("is_active_menu", true);
                            //console.log('Not Global');
                            setLoading(true);
                            const regextesttt = new RegExp(`\/(${Object.values(data.active_slug).map(slug => slug.toLowerCase()).join('|')})$`, 'i');
                            const baseUrl = home_url.replace(regextesttt, '/');
                            redirect_url = `${baseUrl}/${country_code}/${pageSlug}`;
                            sessionStorage.setItem("lastRedirectedSlug", country_code);
                            sessionStorage.setItem("redirect_status", true);
                        } else if (country_code_status === 'Global' && lastRedirectedSlug !== 'Global') {
                            sessionStorage.setItem("is_active_menu", false);
                            //console.log('Global');
                            setLoading(true);
                            const regextesttt = new RegExp(`\/(${Object.values(data.active_slug).map(slug => slug.toLowerCase()).join('|')})$`, 'i');
                            const baseUrl = home_url.replace(regextesttt, '/');
                            redirect_url = `${baseUrl}/${pageSlug}`;
                            sessionStorage.setItem("lastRedirectedSlug", 'Global');
                            sessionStorage.setItem("redirect_status", true);
                            
                        }
                        setshowZHMenuStatus(is_active_menu);
                        if (redirect_url && window.location.href !== redirect_url) {
                            window.location.reload();                        
                        }
                    }//Localization menu active ot not

                    

            } catch (err) {
                if (err.name === "AbortError") {
                    console.warn("Fetch aborted due to timeout or component unmount.");
                    console.error("Error fetching country data:", err);
                } else {
                    console.error("Error fetching country data:", err.message);
                    console.error("Error fetching country data:", err);
                }
            } finally {
                setLoading(false); // Hide the loader after the fetch operation
            }
        }

        fetchCountryData();
        // Cleanup function to abort the fetch when the effect is re-run or the component unmounts
        return () => {
            clearTimeout(timeoutId);
            controller.abort();
        };

    }, []);


    const CountryCodeZhash = Cookies.get("CountryCode_zhash") || "";
    const global_flag = useMemo(() => ZhLocalizationRoot.icon_global, []);
    const others_code_flag = useMemo(() => {
        if (CountryCodeZhash === 'uk') {
            return ZhLocalizationRoot.icon_uk;
        } else if (CountryCodeZhash === 'eu') {
            return ZhLocalizationRoot.icon_eu;
        } else {
            return ZhLocalizationRoot.icon_empty;
        }
    }, [CountryCodeZhash]);

    useEffect(() => {
        // console.log("CountryCodeZhash", CountryCodeZhash);
        // console.log("global_flag", global_flag);
        // console.log("others_code_flag", others_code_flag);
    }, [CountryCodeZhash, global_flag, others_code_flag]);





    useEffect(() => {
        const active_flag_code = sessionStorage.getItem("lastRedirectedSlug");
        const toggleButtonGlobal = sessionStorage.getItem("toggleButtonGlobal");
        
        if(toggleButtonUk === "active" && toggleButtonGlobal !== "active"){
            setActiveClassOthers('active');
            setActiveClassDefault('');
        }else if(toggleButtonEu === "active" && toggleButtonGlobal !== "active"){
            setActiveClassOthers('active');
            setActiveClassDefault('');
        }else if(toggleButtonEu === "active" && toggleButtonGlobal === "active"){
            setActiveClassOthers('');
            setActiveClassDefault('active');
        }else if(toggleButtonUk === "active" && toggleButtonGlobal === "active"){
            setActiveClassOthers('');
            setActiveClassDefault('active');
        }
    }, [activeClassDefault, activeClassOthers, toggleButtonUk, toggleButtonEu]); // Trigger when state changes


    const handleToggleClick = async (event) => {
        const dataValue = event.currentTarget.getAttribute('data-value'); // Retrieve the data-value attribute
        //console.log(`Clicked data-value: ${dataValue}`);

        const pageSlugElement = document.getElementById("page_slug_dynamically_reactjs");
        const pageSlug = pageSlugElement ? pageSlugElement.getAttribute("data-page-slug") : '';
        sessionStorage.setItem("pageSlug", pageSlug);
        Cookies.set("localization_menu_status", 'active', { expires: 1 });

        if(dataValue === 'Global'){
          setActiveClassDefault('active');
          setActiveClassOthers('');
          sessionStorage.setItem("toggleButtonGlobal", "active");
        }else if(dataValue !== 'Global'){
            sessionStorage.setItem("toggleButtonGlobal", "deactive");
          setActiveClassDefault('');
          setActiveClassOthers('active');
        }

        const CountryCodeStatusZhash = Cookies.get("CountryCode_status_zhash") || "";
        const CountryCodeZhash = Cookies.get("CountryCode_zhash") || "";
        const CountryCodeZhashCurrentIp = Cookies.get("countrycode_zhash_current_ip") || "";

        // Show the loader
        setactive_menu_loading(true);
        try {
            // Perform the API call
            const response = await fetch(`${ZhLocalizationRoot.apiUrl}/zh-localization-api/v1/zh-update-country`, {
                method: 'POST',
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                  selected_code: dataValue,
                  CountryCodeStatusZhash: CountryCodeStatusZhash,
                  CountryCodeZhash: CountryCodeZhash,
                  CountryCodeZhashCurrentIp: CountryCodeZhashCurrentIp,
                  page_slug: pageSlug,
                }),
            });
            //const response = await fetch(`${ZhLocalizationRoot.apiUrl}/zh-localization-api/v1/zh-update-country`);
            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }
            const result = await response.json();
            //console.log('API Response:', result);            
            const selected_code =  result.selected_code;
            const current_page_slug =  result.current_page_slug;
            const active_slug =  result.active_slug;            

             // Store specific values in cookies
            if (result.selected_code) {
                Cookies.set("CountryCode_status_zhash", result.selected_code, { expires: 1 });
            }
            if (result.CountryCode_zhash) {
                Cookies.set("CountryCode_zhash", result.CountryCode_zhash, { expires: 1 });
            }
            if (result.countrycode_zhash_current_ip) {
                Cookies.set("countrycode_zhash_current_ip", result.countrycode_zhash_current_ip, { expires: 1 });
            }

            const home_url =ZhLocalizationRoot.HomeUrl;
            let redirect_url = '';
            if(selected_code === "uk"){
                //console.log("Redirect to UK");

                const regextesttt = new RegExp(`\/(${Object.values(result.active_slug).map(slug => slug.toLowerCase()).join('|')})$`, 'i');
                const baseUrl = home_url.replace(regextesttt, '/');
                redirect_url = `${baseUrl}/${selected_code}/${pageSlug}`;
            }else if(selected_code === "eu"){
                //console.log("Redirect to eu");

                const regextesttt = new RegExp(`\/(${Object.values(result.active_slug).map(slug => slug.toLowerCase()).join('|')})$`, 'i');
                const baseUrl = home_url.replace(regextesttt, '/');
                redirect_url = `${baseUrl}/${selected_code}/${pageSlug}`;
            }else if(selected_code === "Global"){
                //console.log("Redirect to Global");

                const regextesttt = new RegExp(`\/(${Object.values(result.active_slug).map(slug => slug.toLowerCase()).join('|')})$`, 'i');
                const baseUrl = home_url.replace(regextesttt, '/');
                redirect_url = `${baseUrl}/${pageSlug}`;
            }

            if (redirect_url && window.location.href !== redirect_url) {
                //window.location.href = redirect_url;
                window.location.reload(); 

                /*const timer = setTimeout(() => {
                    //if (window.location.href !== redirect_url) {
                        window.location.href = redirect_url;
                    //}
                }, 3000); // 3000 ms = 3 seconds              
                return () => clearTimeout(timer);*/

            }
        } catch (error) {
            console.error('Error in toggle API call:', error.message);
            console.error('Error in toggle API call:', error);
        } finally {
            // Hide the loader
            setactive_menu_loading(false);
        }
    };

 

    return (
        <div>
            {loading && (
                <div className="loader-container" id="loadercontainer">
                    <div className="loader1">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    </div>
                </div>
            )}

            {/* Show hello text if the element is found showZHMenuStatus */}            

            { toggleButton === "show" && (
                <div className="toggle-container_zalocalizationmenu">
                    {active_menu_loading && (
                        <div className="loader-zalocalizationmenu">
                            <div className="loader">
                                <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                            </div>
                        </div>
                    )}


                        
                        
                            
                            <div 
                                className={`toggle-btn_zalocalizationmenu ${activeClassDefault}`} 
                                onClick={handleToggleClick} // Attach click handler
                                data-value="Global">
                                <img src={global_flag} alt="Global" className="flag-icon_zalocalizationmenu" /> Global
                            </div>
                        
                            <div 
                                className={`toggle-btn_zalocalizationmenu ${activeClassOthers}`} 
                                onClick={handleToggleClick} // Attach click handler 
                                data-value={CountryCodeZhash}>
                                <img src={others_code_flag} alt={CountryCodeZhash} className="flag-icon_zalocalizationmenu" />
                            </div>                        

                    </div>
            )}
        </div>
    );
}

//export default CountryCheck;
export default React.memo(CountryCheck);